import { Link } from "react-router-dom";
import { Ridgeline } from "@/components/common/Ridgeline";
import { Wordmark } from "@/components/common/Wordmark";

export default function NotFound() {
  return (
    <section
      className="grain relative flex min-h-[100svh] flex-col items-center justify-center overflow-hidden px-6 text-center"
      style={{ backgroundColor: "#24382E" }}
      data-nav-theme="dark"
      data-testid="page-not-found"
    >
      <div className="relative z-10">
        <Wordmark asLink={false} color="#EDE9E0" goldColor="#E3B268" size="text-3xl" />
        <p
          className="font-display mt-10"
          style={{ color: "#F8F5EF", fontSize: "clamp(48px,9vw,120px)", lineHeight: 1 }}
        >
          Off the <span className="italic" style={{ color: "#AEC4C7" }}>map.</span>
        </p>
        <p className="body-measure mx-auto mt-6 text-[17px]" style={{ color: "rgba(237,233,224,0.75)" }}>
          This page wandered off. Let's get you back to somewhere with a good view.
        </p>
        <Link to="/" className="pill pill-gold mt-10 text-base" data-testid="notfound-home-cta">
          Back home
        </Link>
      </div>
      <div className="absolute bottom-0 left-0 z-0 w-full opacity-70">
        <Ridgeline stroke="#C89A4E" variant="b" height={140} />
      </div>
    </section>
  );
}
